import { render, staticRenderFns } from "./UserActivate.vue?vue&type=template&id=c86969a8&"
import script from "./UserActivate.vue?vue&type=script&lang=js&"
export * from "./UserActivate.vue?vue&type=script&lang=js&"
import style0 from "./UserActivate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports